import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/registro',
      name: 'registro',
      // lazy-loaded
      component: () => import('./views/Registro.vue')
    },
    {
      path: '/resultados',
      name: 'resultados',
      // lazy-loaded
      component: () => import('./views/Resultados.vue')
    },
    {
      path: '/resultadosprofesional',
      name: 'resultadosprofesional',
      // lazy-loaded
      component: () => import('./views/ResultadosProfesional.vue'),
      props: true
    },
    {
      path: '/cambiopassword',
      name: 'cambiopassword',
      // lazy-loaded
      component: () => import('./views/CambioPassword.vue')
    },
    {
      path: '/cambiopasswordurl',
      name: 'cambiopasswordurl',
      // lazy-loaded
      component: () => import('./views/CambioPasswordUrl.vue')
    },
    {
      path: '/inicio',
      name: 'inicio',
      // lazy-loaded
      component: () => import('./views/Inicio.vue')
    },
    {
      path: '/profesional',
      name: 'profesional',
      // lazy-loaded
      component: () => import('./views/Profesional.vue')
    },
    {
      path: '/sinresultados0',
      name: 'sinresultados0',
      // lazy-loaded
      component: () => import('./views/SinResultados0.vue')
    }
  ]
});
